import React, { PureComponent } from "react";
import PropTypes from "prop-types";
//Material Imports
import Grow from "@mui/material/Grow";
import Typography from "@mui/material/Typography";

/**
 * This class will take a list of items and call a render method of each of them.
 *
 * For each given component that is rendered a Grow wrapper is given.
 *
 * The Grow wrapper is an animation which if given a delay of a configurable increment.
 *
 * If we have 3 items and the delayIncrement is set to 500ms, the first will appear after 500, second after 1s and third after 1.5s
 *
 */
class AnimateList extends PureComponent {
  render() {
    const {
      items,
      renderListItem,
      delayIncrement,
      selectedItem,
      emptyListMessage
    } = this.props;
    if (!items || items.length === 0) {
      return /*#__PURE__*/React.createElement(Typography, {
        color: "primary"
      }, emptyListMessage);
    }
    let delay = 0;
    return items.map((item, index) => {
      // add the delayIncrement to the delay after each list item
      delay += delayIncrement;
      return /*#__PURE__*/React.createElement(Grow, {
        key: index,
        in: true,
        timeout: delay
      }, /*#__PURE__*/React.createElement("div", null, renderListItem(item, index, selectedItem)));
    });
  }
}
export default AnimateList;
AnimateList.propTypes = {
  items: PropTypes.array.isRequired,
  renderListItem: PropTypes.func.isRequired,
  delayIncrement: PropTypes.number,
  selectedItem: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  emptyListMessage: PropTypes.string
};

/**
 * By default we want the delay of each animation to be 500ms
 */
AnimateList.defaultProps = {
  delayIncrement: 500
};